import React, { useState, useEffect, useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import BootstrapTable from 'react-bootstrap-table-next';
import { LabelText } from '../../../components/Language';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import WeeklyRevenueDetails from './WeeklyRevenueDetails';
import { findUnique } from '../../../common/utility/utility';
import { SubmitSelectionFooter } from '../../../components/UI/SubmitSelectionFooter/SubmitSelectionFooter';
import {isCheckboxSelectionAllowed, checkIsShopOpenStatusCorrect, checkAreInValidValuesForShopOpenYes} from '../RevenueUtility'
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import {changeRequestTooltip} from '../../../components/UI/Tooltip/Tooltip';
import './weekly.css';
import { RevenueCalendarContext } from '../../context/RevenueCalendarProvider';
import { lockedSubmitTooltip } from '../RevenueUtility';
import { OverlayTrigger } from 'react-bootstrap';

function WeeklyRevenue(props) {

  const [error, setError] = useState("");
  const [revenueData, setData] = useState([]);
  const { rawDateError } = useContext(RevenueCalendarContext);
  

  const tableRowStyle = () => {
    const style = {};
    style.backgroundColor = '#EFF4F9';
    style.lineHeight = "8vh";
    return style;
  }

  function InitialFormatRevenueData(initialData) {
    if (initialData && initialData.length > 0) {
      initialData = findUnique(initialData, d => d.contId);
        initialData = initialData.map(d => {
          const rw = checkSelection(d);
            return {
              contId: d.contId,
              contractCode: d.contractCode,
              isContractSelectAllChecked : rw.isSelectAllChecked,
              isContractPartiallyChecked : rw.isPartiallyChecked
            }
        });
    }

    return initialData;
}


  useEffect(() => {
    let changedData = []
    if (props.revenue && props.revenue.length > 0) {
      changedData = InitialFormatRevenueData(props.revenue);
    }
    setData(changedData);

  }, [props.revenue]);

  function selectAllFormatter(column, colIndex) {
    let checkedCount = 0;
    const revData = props.revenue && props.revenue.length > 0 ? props.revenue : [];
    const unSubmittedCount = isHeaderSelectionAllow(revData);    

    checkedCount = revData.filter(d => !d.isSubmitted && d.isMonthlySubmitted &&
      d.isSelectionAllowed && d.isChecked).length;

    let isSelectAllChecked = false, isPartiallyChecked = false;
    if (unSubmittedCount && checkedCount) {

      if (unSubmittedCount === checkedCount) { isSelectAllChecked = true; }       
      else if (unSubmittedCount > checkedCount) { isPartiallyChecked = true;}
    }


    return unSubmittedCount ?
      (
        <div>
          <div style={{ float: "left" }}>
            <input type="checkbox" id={"checkboxAll"} 
              ref={(input) => {
                if (input) {
                  input.indeterminate = isSelectAllChecked ? false : isPartiallyChecked;
                }
              }}
              checked={isSelectAllChecked} 
              onChange={(ev) => handleOnSelectAll(ev)} /></div>
          <div style={{ textAlign: "center", paddingLeft: "1.5vw" }}><span>{column.text}</span></div>
        </div>
      )
      : (<span>{column.text}</span>)
  }

  const handleOnSelectAll = (ev) => {
    
    const isPartiallyChecked = props.revenue && props.revenue.length > 0 
                    && props.revenue.some(d => d.isChecked);
    
    props.revenue && props.revenue.length > 0 && props.revenue.map(d => {
      if (!d.isSubmitted && d.isMonthlySubmitted) {

        if (d.isSelectionAllowed) {
          d.isChecked = !isPartiallyChecked && ev.target.checked;
          props.setRevenueData(d.index, d.contractCode, d);
        } else if (d.isShopOpen === "Yes") {
          checkAreInValidValuesForShopOpenYes(d, true, true, setError, error, 
              props.setRevenueData, props.setErrorPopUpHandler);
        }
      }
    });
  }

  function checkSelection(row) {
    let checkedCount = 0;
    let selectedObject = {};
    const revData = props.revenue.filter(d => d.contId === row.contId);
    
    const unSubmittedCount = isContractHeaderSelectionAllow(revData);

    checkedCount = revData.filter(d => !d.isSubmitted && d.isMonthlySubmitted &&
      d.isSelectionAllowed && d.isChecked).length;


    if (unSubmittedCount && checkedCount) {
      if (unSubmittedCount === checkedCount) { 
        selectedObject = {"isSelectAllChecked" : true,"isPartiallyChecked" : false}
       } 
      else if (unSubmittedCount > checkedCount) { selectedObject = {"isSelectAllChecked" : false,"isPartiallyChecked" : true}}
    }

    return selectedObject;
  }
  

  function selectCheckboxFormatter(row, extraData) {
    
    const isSelectionAllowed = extraData.some(d => d.contId === row.contId && d.isSelectionAllowed );
    

    

    return (
        <div>
          <div>
            <input type="checkbox"  id={row.contId}
              ref={(input) => {
                if (input) {
                  input.indeterminate = row.isContractSelectAllChecked ? false : row.isContractPartiallyChecked;
                }
              }}
              checked={row.isContractSelectAllChecked} 
              onChange={(ev) => handleOnContractSelectAll(ev, row)} 
              disabled= {!isSelectionAllowed}/>
              </div>
        </div>
      )
  }

  const handleOnContractSelectAll = (ev, row) => {
    
    const arr= props.revenue.filter(d => d.contractCode === row.contractCode);
    const isPartiallyChecked = arr && arr.length > 0 && arr.some(d => d.isChecked);
                      
    arr && arr.length > 0 && arr.map(d => {
      if (!d.isSubmitted && d.isMonthlySubmitted) {
        if (d.isSelectionAllowed) {
          d.isChecked = !isPartiallyChecked && ev.target.checked;
          props.setRevenueData(d.index, d.contractCode, d);
        } else if (d.isShopOpen === "Yes") {
          checkAreInValidValuesForShopOpenYes(d, true, true, setError, error, 
              props.setRevenueData, props.setErrorPopUpHandler);
        }

      }
    });
  }

  

  const contractCheckboxFormatter = (row, extraData) => {
    let arr = props.revenue.filter(d => d.contractCode === row.contractCode);
    let monthlySubmitted = arr.every(d => d.isMonthlySubmitted === false);
    let isSubmitted = arr.every(d => d.isSubmitted === true);
    return (
      
        isSubmitted ? <div></div> : <div style={{ float: "left", marginLeft: "0.8vw" }}>
         {monthlySubmitted ? <OverlayTrigger placement="left"
                overlay={lockedSubmitTooltip}>
                <div className="fa-lock" />
            </OverlayTrigger> : selectCheckboxFormatter(row, extraData)}
        </div>
      
    )
  }

  const contractUnblockIconFormatter = (row, extraData) => {
    let arr = props.revenue.filter(d => d.contractCode === row.contractCode);
    let data = arr[0];
    let isUnblockChangeRequestAllowed = arr.every(d => d.isUnblockChangeRequestAllowed === true);
    let isUnblockPending = arr.every(d => d.isUnblockChangeRequestAllowed === false && d.unblockChangeRequest && d.unblockChangeRequest.changeRequestStatus && d.unblockChangeRequest.changeRequestStatus === 1);
    let actionIcon=<div></div>;

    if (isUnblockChangeRequestAllowed) {
      actionIcon = <CustomOverlayTrigger placement="left"
        tooltip={changeRequestTooltip("unblock_request")}>
        <div  className="fa-cr-unblock" role={"button"} tabIndex={0} 
          style={{ marginLeft: "2vw" }}
          onClick={(ev) => row && props.handlerOnUnblockRequestIconClick(data, data.index)}
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              row && props.handlerOnUnblockRequestIconClick(data, data.index)
            }
          }}
        />
      </CustomOverlayTrigger>
    }
    else if (isUnblockPending) {
      actionIcon = <CustomOverlayTrigger placement="left"
        tooltip={changeRequestTooltip("cr_pending", data.unblockChangeRequest.changeRequestNumber)}>
        <FontAwesomeIcon style={{marginLeft: "1vw"}} className={"fa-cr-inprogress"} icon={faHourglassHalf} />
      </CustomOverlayTrigger>
    }

    
    return (actionIcon);
  }

  const contractErrorFormatter = (row, extraData) => {
    let arr = props.revenue.filter(d => d.contractCode === row.contractCode);
    let dataError = false;
    arr.map(d => {
      if (d.tax_0_ErrorMessage || d.tax_6_ErrorMessage || d.tax_12_ErrorMessage || d.tax_21_ErrorMessage || d.soldTicket_ErrorMessage || d.isShopOpen_ErrorMessage || d.remarks_ErrorMessage) {
        dataError = true;
      }
    });
        
    return (
      dataError ? <div style={{ color:"red"}}>{row.contractCode}</div> : <div>{row.contractCode}</div>
    )
  }

  const columns = [
    {
      dataField: 'contId',
      hidden: true
    },
    {
      dataField: 'contractCode',
      text: <LabelText tid="contractcode" />,
      classes: "Contractcode",
      editable: false,
      headerClasses: "Contractcode-header",
      formatExtraData: props.revenue,
      formatter: (cell, row, rowIndex, extraData) => contractErrorFormatter(row, extraData)
    },
    {
      text: <LabelText tid="Shop_Open" />,
      classes: "Shopopen",
      headerClasses: "Shopopen-header",
      editable: false
    },
    {
      text: <LabelText tid="remarks" />,
      headerClasses: "Remarks-header",
      classes: "Remarks",
      editable: false
    },
    {
      text: <LabelText tid="Tax_0" />,
      headerClasses: "Vat-header",
      editable: false
    },
    {
      headerClasses: "Vat-header",
      text: <LabelText tid="Tax_6" />,
      editable: false      
    },
    {
      headerClasses: "Vat-header",
      editable: false,
      text: <LabelText tid="Tax_12" />            
    },
    {
      text: <LabelText tid="Tax_21" />,
      headerClasses: "Vat-header",
      editable: false
    },
    {
      headerClasses: "Soldtickets-header",
      text: <LabelText tid="Sold_Ticket" />,
      editable: false      
    },
    {
      text: <LabelText tid="status" />,
      headerClasses: "Submit-header",
      headerFormatter: selectAllFormatter,
      editable: true ,
      formatExtraData: props.revenue,
      formatter: (cell, row, rowIndex, extraData) => contractCheckboxFormatter(row, extraData)      
    },
    {
      text: <LabelText tid="actions" />,
      editable: false,
      headerClasses: "Submit-header",
      classes: "Status",
      formatExtraData: props.revenue,
      formatter: (cell, row, rowIndex, extraData) => contractUnblockIconFormatter(row, extraData)
      
    }
  ];

  const isHeaderSelectionAllow = (revData) => {

    const noOfUnsubmittedContracts = revData.some(d => !d.isSubmitted && d.isMonthlySubmitted) ?
      revData.filter(d => !d.isSubmitted && d.isMonthlySubmitted).length : 0;

    return noOfUnsubmittedContracts && noOfUnsubmittedContracts > 0 ? noOfUnsubmittedContracts : 0;
  }

  const isContractHeaderSelectionAllow = (revData) => {

    const noOfUnsubmittedContracts = revData.some(d => !d.isSubmitted && d.isMonthlySubmitted) ?
      revData.filter(d => !d.isSubmitted && d.isMonthlySubmitted).length : 0;

    return noOfUnsubmittedContracts && noOfUnsubmittedContracts > 0 ? noOfUnsubmittedContracts : 0;
  }

  const isSubmitSelectionAllowed = props.revenue && props.revenue.length > 0 && props.revenue.some(d => !d.isSubmitted && d.isMonthlySubmitted && d.isSelectionAllowed && d.isChecked);

  const expandRow = {
    renderer: row => (
      <div className="row">
        <div className="expanded-renderer-column" />
        <div className="expanded-renderer-content" >
          <WeeklyRevenueDetails
            key={row.contId}
            revenue={props.revenue.filter(c => c.contId === row.contId)}
            setRevenueData={props.setRevenueData}
            submitRevenue={props.submitRevenue}
            isSuccessfulSubmitted={props.isSuccessfulSubmitted}
            isError={props.isError}
            errorMessage={props.errorMessage}
            resetSubmittedAndErrorFlags={props.resetSubmittedAndErrorFlags}
            remarksOptions={props.remarksOptions}
            setErrorPopUpHandler={props.setErrorPopUpHandler}
            cancelChangeRequestHandler={props.cancelChangeRequestHandler}
            submitSelectedRevenueHandler={props.submitSelectedRevenueHandler}
            dataLoading={props.dataLoading}
            handlerOnUnblockRequestIconClick={props.handlerOnUnblockRequestIconClick}
            setError={setError}
            error={error}
            checkAreInValidValuesForShopOpenYes={checkAreInValidValuesForShopOpenYes}
            checkIsShopOpenStatusCorrect={checkIsShopOpenStatusCorrect}
            isCheckboxSelectionAllowed={isCheckboxSelectionAllowed}
          />
        </div>
      </div>
    ),
    showExpandColumn: true,
    expandColumnRenderer: ({ expanded }) => {
      return <FontAwesomeIcon className="fa-arrow" icon={expanded ? faChevronDown : faChevronUp} />
    },
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  return (
    <Container>
      <Row className="row-style">
        <BootstrapTable
          keyField='contId'
          data={revenueData}
          columns={columns.filter(c => c)}
          bordered
          noDataIndication={(props.dataLoading || (props.revenue && props.revenue.length > 0)) ? <LabelText tid="data_loading" />
            : <LabelText tid="Noactivecontract" />}
          rowStyle={tableRowStyle}
          classes={"weekly-revenue-datatable row scroller"}
          headerClasses={"weekly-revenue-datatable-header"}
          expandRow={expandRow}
        />
      </Row>
      <Row className="row-style">
        <SubmitSelectionFooter isSubmitSelectionAllowed={isSubmitSelectionAllowed}
          showSelectionFooter={isHeaderSelectionAllow(props.revenue && props.revenue.length > 0 
                                            ? props.revenue : [])}
          selectedDate={props.revenueDate}
          selectedData={props.revenue && props.revenue.length > 0 ? props.revenue.filter(
            d => !d.isSubmitted && d.isMonthlySubmitted && d.isSelectionAllowed && d.isChecked
          ) : []}          
          selectedCount={isSubmitSelectionAllowed ?
            props.revenue.filter(d => !d.isSubmitted && d.isMonthlySubmitted && d.isSelectionAllowed && d.isChecked).length
            : 0
          }
          submitSelectedHandler={props.submitSelectedRevenueHandler}
        />
      </Row>
      <Row className="row-style">
        {
          <div style={{ width: '100%' }}>
            {
              <div className="Error-container-Footer">
                {error && error.trim() !== "" ? <>
                  <div className="Error-icon" />
                  <div className="Errormsg">
                    <LabelText tid={error} />
                  </div>
                </>
                : rawDateError && rawDateError.trim() !== "" ? <>
                    <div className="Error-icon" />
                    <div className="Errormsg">
                        <LabelText tid={rawDateError} />
                    </div>
                </>
                    : undefined}
              </div>
            }
          </div>
        }
      </Row>
    </Container>
  )
}

export default WeeklyRevenue;